export default "__VITE_ASSET__DRn046cL__"